<template>
  <div class="history" :class="{ 'animate-flicker': loading }">
    <div class="nav-top">
      <div class="title">LAPORAN KENDALI KERJA</div>
    </div>

    <div class="btn-group">
      <button @click="show = 'ALL'">Semua</button>
      <button @click="show = 'INDEX'">Index</button>
    </div>

    <div class="body">
      <div class="summary" v-show="show == 'ALL'">
        <div class="card todo">
          <h1>{{ summary.TODO }}</h1>
          <p>Todo</p>
        </div>
        <div class="card progress">
          <h1>{{ summary.IN_PROGRESS }}</h1>
          <p>In Progress</p>
        </div>
        <div class="card complete">
          <h1>{{ summary.COMPLETE }}</h1>
          <p>Complete</p>
        </div>
        <div class="card all">
          <h1>{{ summary.ALL }}</h1>
          <p>All</p>
        </div>
      </div>

      <div class="filter" v-show="show == 'ALL'">
        <form @submit.prevent="doFilter">
          <select v-model="filter.nama">
            <option value="">Semua User</option>
            <option v-for="(item, index) in user" :key="index" :value="item.nama">
              {{ item.unit_kerja || item.nama }}
            </option>
          </select>
          <select v-model="filter.status">
            <option value="ALL">Semua Status</option>
            <option value="TODO">TODO</option>
            <option value="IN_PROGRESS">IN PROGRESS</option>
            <option value="COMPLETE">COMPLETE</option>
          </select>
          <button type="submit" class="btn btn-primary">Filter</button>
        </form>
      </div>

      <div class="table-wrapper" v-show="show == 'ALL'">
        <table style="width: 100%">
          <thead>
            <tr>
              <th style="width: 30px">No</th>
              <th style="width: 120px">Nama</th>
              <th style="width: 200px">Unit Kerja</th>
              <th style="width: 350px">Pekerjaan</th>
              <th style="width: 350px">Keterangan</th>
              <th style="width: 100px">Tgl Target</th>
              <th style="width: 140px">Status</th>
              <th style="white-space: nowrap; width: 250px" v-for="(item, index) in tableHeader" :key="index">
                {{ moment(item).format("DD-MM-YY") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index" @click="selectTask(item)">
              <td>{{ ++index }}</td>
              <td style="white-space: nowrap">{{ item.pegawai }}</td>
              <td>{{ item.divisi }}</td>
              <td>{{ item.nama }}</td>
              <td>
                <div v-if="item.keterangan != 'null'" v-html="item.keterangan"></div>
              </td>
              <td>{{ moment(item.tgl_target).format("DD MMM YYYY") }}</td>
              <td>
                <span :class="item.status == 'COMPLETE'
    ? 'complete'
    : item.diff < 0 && item.status != 'COMPLETE'
      ? 'danger'
      : item.status.toLowerCase()
    ">
                  {{ item.status }}</span>
              </td>
              <td v-for="(tgl, index) in tableHeader" :key="index">
                {{ findProgress(item.id, tgl) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-wrapper" v-show="show == 'INDEX'">
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>User</th>
              <th @click="sortBy('todo')">Total TODO</th>
              <th @click="sortBy('inprogress')">Total IN PROGRESS</th>
              <th @click="sortBy('complete')">Total COMPLETE Minggu Kemarin</th>
              <th @click="sortBy('rata2')">Rata2 Todo - Complete</th>
              <th @click="sortBy('rata2_inprogress')">
                Rata2 Inprogress - Complete
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataIndexing" :key="index">
              <td>{{ ++index }}</td>
              <td>{{ item.user }}</td>
              <td>{{ item.total_todo }}</td>
              <td>{{ item.total_inprogress }}</td>
              <td>{{ item.total_complete }} ({{ item.persen_complete }}%)</td>
              <td>{{ item.rata2_hari_complete }} hari</td>
              <td>{{ item.rata2_hari_inprogress_complete }} hari</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal" v-show="modalOpen" @click="closeModal">
      <div class="modal-body">
        <div class="top">
          <div>
            <p style="font-size: 14px">
              {{ selectedTask.pekerjaan.pegawai }} ({{
    selectedTask.pekerjaan.divisi
  }})
            </p>
            <b style="font-size: 16px; text-transform: uppercase">{{
      selectedTask.pekerjaan.nama
    }}</b>

            <p>
              <small>
                Target Selesai pada
                {{
      moment(selectedTask.pekerjaan.tgl_target).format(
        "DD MMM YYYY"
      )
    }}
              </small>
            </p>
          </div>
          <div>
            <span v-if="selectedTask.pekerjaan.status" :class="selectedTask.pekerjaan.status == 'COMPLETE'
    ? 'complete'
    : selectedTask.pekerjaan.diff < 0 &&
      selectedTask.pekerjaan.status != 'COMPLETE'
      ? 'danger'
      : selectedTask.pekerjaan.status.toLowerCase()
    ">
              {{ selectedTask.pekerjaan.status }}</span>
          </div>
        </div>

        <div class="keterangan" v-html="selectedTask.pekerjaan.keterangan == 'undefined'
    ? '-'
    : selectedTask.pekerjaan.keterangan
    "></div>

        <p>History Progress:</p>
        <ul>
          <li>
            <span>{{
    moment(selectedTask.pekerjaan.created_at).format(
      "DD MMM YYYY HH:mm"
    )
  }}
            </span>
            <p>Membuat pekerjaan</p>
          </li>
          <li v-for="(item, index) in selectedTask.progress" :key="index">
            <span>{{ moment(item.created_at).format("DD MMM YYYY HH:mm") }}
            </span>
            <p>{{ item.keterangan == "undefined" ? "-" : item.keterangan }}</p>
          </li>
        </ul>

        <div>
          <p style="text-align: center">
            <img :src="selectedTask.pekerjaan.gambar" width="60%" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as api from "../api/Api";

import Right from "./icons/Right.vue";

export default {
  name: "Home",
  components: {
    Right,
  },
  data() {
    return {
      loading: false,
      data: [],
      tmpData: [],
      summary: {
        TODO: 0,
        IN_PROGRESS: 0,
        COMPLETE: 0,
        CANCEL: 0,
        ALL: 0,
      },
      progress: [],
      tableHeader: [],
      user: [],
      filter: {
        nama: "",
        status: "ALL",
      },
      modalOpen: false,
      selectedTask: {
        pekerjaan: {},
      },
      dataIndexing: [],
      lastSort: "",
      show: "ALL",
    };
  },
  methods: {
    moment,
    loadSummary() {
      let param = "";
      api
        .get("/v1/kendali_kerja/pekerjaanController/summary?" + param)
        .then((r) => {
          this.summary = {
            TODO: 0,
            IN_PROGRESS: 0,
            COMPLETE: 0,
            CANCEL: 0,
            ALL: 0,
          };

          r.data.forEach((item) => {
            this.summary[item.status] = item.total;
          });

          this.summary.ALL =
            parseInt(this.summary.TODO) +
            parseInt(this.summary.IN_PROGRESS) +
            parseInt(this.summary.COMPLETE);
        });
    },
    loadIndexing() {
      api.get("/v1/kendali_kerja/pekerjaanController/indexing").then((r) => {
        this.dataIndexing = r.data;

        this.dataIndexing.forEach((item) => {
          item.persen_complete = (
            (item.total_complete /
              (parseInt(item.total_complete) +
                (parseInt(item.total_todo) +
                  parseInt(item.total_inprogress)))) *
            100
          ).toFixed(2);

          // if (item.persen_complete == "Infinity") {
          //   item.persen_complete = 100;
          // }

          item.rata2_hari_complete = (item.rata2_complete * 1).toFixed(0);
          item.rata2_hari_inprogress_complete = (
            item.rata2_inprogress_complete * 1
          ).toFixed(0);
        });
      });
    },
    loadData() {
      api.get("/v1/kendali_kerja/pekerjaanController/laporan").then((r) => {
        this.data = r.data;
        this.tmpData = r.data;

        this.data.forEach((item) => {
          if (item.keterangan == "undefined") {
            item.keterangan = "-";
          }
        });

        api
          .get("/v1/kendali_kerja/pekerjaanController/getProgress")
          .then((res) => {
            this.progress = res.data;

            this.tableHeader = Object.keys(this.progress);
          });
      });
    },
    findProgress(idPekerjaan, tanggal) {
      const pekerjaan = this.progress[tanggal].find((k) => {
        return k.id_pekerjaan == idPekerjaan;
      });

      return pekerjaan ? pekerjaan.keterangan : "-";
    },
    doFilter() {
      this.data = this.tmpData;

      if (this.filter.nama && this.filter.status != "ALL") {
        // summary dulu, terus filter status
        this.data = this.data.filter((item) => {
          if (item.pegawai) {
            return (
              item.pegawai
                .toLowerCase()
                .indexOf(this.filter.nama.toLowerCase()) > -1
            );
          }
        });
        this.getSummary();

        //
        this.data = this.data.filter((item) => {
          return (
            item.pegawai.toLowerCase().indexOf(this.filter.nama.toLowerCase()) >
            -1 &&
            item.status
              .toLowerCase()
              .indexOf(this.filter.status.toLowerCase()) > -1
          );
        });
      } else if (this.filter.nama) {
        this.data = this.data.filter((item) => {
          if (item.pegawai) {
            return (
              item.pegawai
                .toLowerCase()
                .indexOf(this.filter.nama.toLowerCase()) > -1
            );
          }
        });
        this.getSummary();
      } else if (this.filter.status != "ALL") {
        this.data = this.data.filter((item) => {
          return (
            item.status
              .toLowerCase()
              .indexOf(this.filter.status.toLowerCase()) > -1
          );
        });
      }
    },
    getSummary() {
      this.summary.TODO = 0;
      this.summary.IN_PROGRESS = 0;
      this.summary.COMPLETE = 0;

      this.data.forEach((item) => {
        if (item.status == "TODO") {
          this.summary.TODO += 1;
        } else if (item.status == "IN_PROGRESS") {
          this.summary.IN_PROGRESS += 1;
        } else if (item.status == "COMPLETE") {
          this.summary.COMPLETE += 1;
        }
      });

      this.summary.ALL =
        parseInt(this.summary.TODO) +
        parseInt(this.summary.IN_PROGRESS) +
        parseInt(this.summary.COMPLETE);
    },
    selectTask(item) {
      this.modalOpen = true;
      this.fetchDetail(item.id);

      document.querySelector("BODY").style.overflow = "hidden";
    },
    closeModal(e) {
      if (e.target.classList[0] == "modal") {
        this.selectedTask = {
          pekerjaan: {},
        };
        this.modalOpen = false;
        document.querySelector("BODY").style.overflow = "auto";
      }
    },
    fetchDetail(id) {
      api
        .get("/v1/kendali_kerja/PekerjaanController/detail?id=" + id)
        .then((r) => {
          this.selectedTask = r.data;
        });
    },
    sortBy(col) {
      if (col == "todo") {
        if (this.lastSort == "todo") {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.total_todo) < parseInt(b.total_todo)) {
              return -1;
            }
            if (parseInt(a.total_todo) > parseInt(b.total_todo)) {
              return 1;
            }
            return 0;
          });

          this.lastSort = "";
        } else {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.total_todo) > parseInt(b.total_todo)) {
              return -1;
            }
            if (parseInt(a.total_todo) < parseInt(b.total_todo)) {
              return 1;
            }
            return 0;
          });

          this.lastSort = "todo";
        }
      }
      if (col == "inprogress") {
        if (this.lastSort == "inprogress") {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.total_inprogress) < parseInt(b.total_inprogress)) {
              return -1;
            }
            if (parseInt(a.total_inprogress) > parseInt(b.total_inprogress)) {
              return 1;
            }
            return 0;
          });

          this.lastSort = "";
        } else {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.total_inprogress) > parseInt(b.total_inprogress)) {
              return -1;
            }
            if (parseInt(a.total_inprogress) < parseInt(b.total_inprogress)) {
              return 1;
            }
            return 0;
          });

          this.lastSort = "inprogress";
        }
      }
      if (col == "complete") {
        if (this.lastSort == "complete") {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.total_complete) < parseInt(b.total_complete)) {
              return -1;
            }
            if (parseInt(a.total_complete) > parseInt(b.total_complete)) {
              return 1;
            }
            return 0;
          });

          this.lastSort = "";
        } else {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.total_complete) > parseInt(b.total_complete)) {
              return -1;
            }
            if (parseInt(a.total_complete) < parseInt(b.total_complete)) {
              return 1;
            }
            return 0;
          });

          this.lastSort = "complete";
        }
      }
      if (col == "rata2") {
        if (this.lastSort == "rata2") {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.rata2_complete) < parseInt(b.rata2_complete)) {
              return -1;
            }
            if (parseInt(a.rata2_complete) > parseInt(b.rata2_complete)) {
              return 1;
            }
            return 0;
          });
          this.lastSort = "";
        } else {
          this.dataIndexing.sort((a, b) => {
            if (parseInt(a.rata2_complete) > parseInt(b.rata2_complete)) {
              return -1;
            }
            if (parseInt(a.rata2_complete) < parseInt(b.rata2_complete)) {
              return 1;
            }
            return 0;
          });
          this.lastSort = "rata2";
        }
      }
      if (col == "rata2_inprogress") {
        if (this.lastSort == "rata2_inprogress") {
          this.dataIndexing.sort((a, b) => {
            if (
              parseInt(a.rata2_inprogress_complete) <
              parseInt(b.rata2_inprogress_complete)
            ) {
              return -1;
            }
            if (
              parseInt(a.rata2_inprogress_complete) >
              parseInt(b.rata2_inprogress_complete)
            ) {
              return 1;
            }
            return 0;
          });
          this.lastSort = "";
        } else {
          this.dataIndexing.sort((a, b) => {
            if (
              parseInt(a.rata2_inprogress_complete) >
              parseInt(b.rata2_inprogress_complete)
            ) {
              return -1;
            }
            if (
              parseInt(a.rata2_inprogress_complete) <
              parseInt(b.rata2_inprogress_complete)
            ) {
              return 1;
            }
            return 0;
          });
          this.lastSort = "rata2_inprogress";
        }
      }
    },
  },
  mounted() {
    this.loadSummary();
    this.loadData();
    this.loadIndexing();

    api.get("/v1/users/getByPlatform?platform=KENDALI_KERJA").then((r) => {
      this.user = r;
    });
  },
};
</script>

<style scoped lang="scss">
.history {
  background: #fff;
  min-height: 100vh;
  padding-bottom: 60px;

  .nav-top {
    background: #fff;
    box-shadow: 0px 2px 3px #ccc;
    display: flex;
    margin-bottom: 2px;

    .title {
      font-size: 14px;
      font-weight: bold;
      padding: 15px;
    }
  }

  .btn-group {
    margin: 20px 15px;
    display: flex;
    align-items: center;

    button {
      margin: 0 5px;
      padding: 5px 10px;
    }
  }

  .body {
    padding: 15px;

    .summary {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 25px;
      margin-bottom: 20px;
    }

    .filter {
      width: 50%;
      margin: 20px 0;

      form {
        display: grid;
        grid-template-columns: repeat(2, 1fr) 140px;
        grid-column-gap: 15px;

        input,
        select {
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 15px;

          &:focus {
            border: 1px solid var(--primary);
          }
        }

        input {
          width: calc(100% - 30px);
        }

        button {
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }

    .card {
      border-radius: 5px;
      padding: 20px;
      color: #333;

      h1,
      p {
        margin: 0;
      }

      &.todo {
        background: #fff;
        border: 1px solid #ccc;
      }

      &.progress {
        background: #f5b400;
        border: 1px solid #f5b400;
      }

      &.complete {
        background: #6ee569;
        border: 1px solid #6ee569;
      }

      &.all {
        background: #009be7;
        border: 1px solid #009be7;
      }
    }

    .table-wrapper {
      display: block;
      overflow: auto;
      width: 100%;
    }

    table {
      width: 1500px;
      border-collapse: collapse;

      th {
        padding: 10px;
        border-bottom: 2px solid #ccc;
        font-size: 13px;
        text-align: left;
      }

      tr:hover {
        cursor: pointer;

        td {
          background: #f8f8f8;
        }
      }

      td {
        padding: 10px;
        border-bottom: 1px solid #ccc;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }

  span {
    font-size: 11px;
    background-color: #eee;
    padding: 5px 10px;
    border-radius: 5px;

    &.in_progress {
      background: #f5b400;
    }

    &.complete {
      background: #6ee569;
    }

    &.danger {
      background: #d64948;
      color: #fff;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;

    .modal-body {
      width: 600px;
      background: #fff;
      padding: 15px;
      border-radius: 10px;
      height: 70vh;
      margin-top: 50px;
      overflow-y: auto;

      .top {
        display: flex;
        justify-content: space-between;

        p {
          margin: 0 0 5px;
        }

        pre {
          background: #eee;
          width: 100%;
        }
      }

      .keterangan {
        padding: 10px;
        background: #eee;
        margin-top: 15px;
        border-radius: 5px;
        min-height: 50px;

        p {
          margin: 0;
          font-size: 14px;
        }
      }

      ul {
        margin: 0;
        padding-left: 20px;

        li {
          font-size: 14px;
          margin: 20px 0;
          border-bottom: 1px solid #ccc;
          padding-bottom: 10px;

          span {
            background: none;
            font-size: 14px;
            padding: 0;
            font-weight: 500;
          }

          p {
            margin: 0;
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Laporan.vue